export enum CustomerType {
  ScanaEnergy = 'Scana Energy',
  ScanaRegulated = 'Scana Regulated',
}
